import { Controller } from 'stimulus'
import tippy, { createSingleton } from 'tippy.js'
import 'tippy.js/dist/tippy.css'

// One shared tooltip for a group of neighboring elements (e.g. the muted
// info-panel tabs on a CFM task). Unlike one tooltip per element, the single
// bubble moves between targets, so sweeping the mouse across the group never
// stacks several lingering tooltips on screen at once.
//
// Mark members with data-target="tooltip-group.item" and give each a title.
export default class extends Controller {
  static targets = ['item']

  connect() {
    if (window.innerWidth <= 1024) return
    this.instances = this.itemTargets
      .map((el) => {
        // Stash the text so reconnects (turbolinks restore) still have it
        // after the title attribute is stripped.
        const node = el
        const content = node.title || node.dataset.tooltipGroupContent || ''
        if (content.length < 2) return null
        node.dataset.tooltipGroupContent = content
        node.removeAttribute('title')
        return tippy(node, { content })
      })
      .filter(instance => instance)
    if (!this.instances.length) return

    this.singleton = createSingleton(this.instances, {
      theme: 'light-border',
      animation: 'fade',
      moveTransition: 'transform 0.15s ease-out',
      appendTo: () => document.body
    })
  }

  disconnect() {
    if (this.singleton) this.singleton.destroy()
    if (this.instances) this.instances.forEach(instance => instance.destroy())
    this.singleton = null
    this.instances = null
  }
}
